import { HttpHeaders } from '@angular/common/http';
export const httpHeaders = new HttpHeaders({
  Accept: 'application/json, text/event-stream, application/octet-stream, text/plain;charset=UTF-8',
  'Access-Control-Allow-Origin': '*',
  'X-BOD-APP-CODE': 'NEMI',
  'Content-Type': 'application/json'
});

export const httpHeadersMultipart = new HttpHeaders({
  Accept: 'application/json, text/event-stream, multipart/form-data',
  'Access-Control-Allow-Origin': '*',
  'X-BOD-APP-CODE': 'NEMI',
});
